import React, { useEffect, useState } from 'react';
import { DistrictsVService } from '../../../services/V2/padre';
import { dateToLocal, formatMoney, handleError, handleErrorToast } from '../../shared/Functions';
import { AutoPaysVService } from '../../../services/V2/gozer';
import { AutoPaysVService as AutopaymentService } from '../../../services/V3/charon';
import { Grid, Link } from '@material-ui/core';
import { CustomTable } from '../../shared/CustomTable';
import '../../../scss/UVP.scss';
import { ConfirmModal } from '../../shared/ConfirmModal';

export const UVPAutoPay = ({errorToast, successToast, setSelectedPayment, districtId, refresh, setRefresh, setLoading, setRunningBatch}) => {
    const tableRef: any = React.createRef();

    const [district, setDistrict] = useState<any>();
    const [disablePayments, setDisablePayments] = useState<any>(false);
    const [batchId, setBatchId] = useState<string | null>(null);
    const [paymentId, setPaymentId] = useState<string>("");
    const today = new Date()
    const checkTime = today.setHours(today.getHours() - 8)

    useEffect(() => {
        if(!refresh)
            setRefresh(true)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!districtId) return;
        tableRef?.current?.onQueryChange();
        DistrictsVService.districtsVGetById(districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => handleError(x))
    }, [districtId])// eslint-disable-line react-hooks/exhaustive-deps

    const rerunAutoPay = () => {
        setBatchId(null)
        setDisablePayments(true)
        setLoading(true)
        AutopaymentService.autoPaysVRerunFailedPayments(paymentId)
            .then(x => {
                successToast(`Running. You can leave the page and come back for results. If issues persist, please contact customer support.`)
                setLoading(false)
                setRunningBatch(true)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }

    const createBatch = () => {
        setLoading(true)
        AutopaymentService.autoPaysVCreateBatch(district.id)
            .then(x => {
                successToast(`Batch is being created. Please wait.`)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }

    if(!district) return null;

    return (
        <React.Fragment>
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setBatchId(null)}
                show={batchId}
                confirmCallback={() => rerunAutoPay()}
                title={"ReRun Failed Payments"}
                description={`Are you sure you want to rerun all failed Recurring Payments in Batch ${batchId}?`} />
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button className='uvp-button gray-button' onClick={() => setRefresh(true)}>Refresh</button>
                    <button className='uvp-button green-button' onClick={createBatch}>Create Batch</button>
                </div>
                <div style={{backgroundColor: "white", borderRadius: "10px", marginTop: "20px"}}>
                    <CustomTable
                        refresh={refresh}
                        columns={[
                            { title: 'Batch ID', field: 'batchId', render: rowData => <Link className="clickable" onClick={() => setSelectedPayment(rowData)}>{rowData.batchId}</Link> },
                            { title: 'Batch Status', field: '',
                                render: rowData => rowData.error ? "Error" : rowData?.canceled ? "Canceled" : !rowData.hasBeenRun ? "Pending" :
                                    rowData.paymentResults && rowData.paymentResults.length > 0 ? "Processed" : "Processing"
                            },
                            { title: 'Run Date', field: 'runDate', render: rowData => rowData.runDate ? dateToLocal(rowData.runDate).toLocaleString() : null },
                            { title: 'Resubmit Date', field: 'reRunDate', render: rowData => rowData.reRunDate ? dateToLocal(rowData.reRunDate).toLocaleString() : null },
                            { title: 'Approved', field: 'successes' },
                            { title: 'Declined', field: 'declines' },
                            { title: 'Error', field: 'failures', render: rowData => 
                                (rowData.failures > 0 && !disablePayments && !rowData.hasBeenRerun && (new Date(rowData.runDate) >= new Date(checkTime))) ? 
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <div>{rowData.failures}&nbsp;</div>
                                        <Link className="clickable" onClick={() => {
                                                setBatchId(rowData.batchId)
                                                setPaymentId(rowData.id)
                                            }}>Resubmit</Link>
                                    </div>
                                : 
                                <div>{rowData.failures}</div>
                            },
                            { title: 'Total Count', field: 'batchCount' },
                            { title: 'Total Value', field: 'batchAmount', render: rowData => formatMoney(rowData.batchAmount) },
                        ]}
                        dataEndpoint={AutoPaysVService.autoPaysVGetAll}
                        dataSet={null}
                        pageSize={15}
                        enablePaging={false}
                        actions={[]}
                        setRefresh={setRefresh}
                        title={''}
                        districtId={districtId}
                        addedQuery={null}
                        hiddenColumns={[]}
                        setHiddenColumns={null}
                        hiddenColumnsDisabled={true}
                        tableHeight={"407px"}
                        enableSearch={false}
                        searchPlaceholder={null} />
                </div>
            </Grid>
        </React.Fragment>
    );
}
